<section id="board">

    <!-- <div class="container">
        <div class="inner-container">
            <div class="thrift">
                <img *ngIf="loading" style="width: 80%;" (load)="onLoad()" src="/assets/loader.gif" alt="loading" />
                <a routerLink="/thrift">
                    <img *ngIf="!loading"  src="./assets/thrift.jpg" alt="" srcset="">
                </a>
                <h3 *ngIf="!loading">thrift</h3>
            </div>
            <div class="campaign">
                <img  *ngIf="loading" style="width: 80%;" (load)="onLoad()" src="/assets/loader.gif" alt="loading" />
                <a routerLink="/logs">
                <img *ngIf="!loading" src="./assets/campaign.jpg" alt="" srcset="">
                </a>
                <h3 *ngIf="!loading">My Thrift Logs</h3>
            </div>
            <div class="event">
                <img *ngIf="loading" style="width: 80%;" (load)="onLoad()" src="/assets/loader.gif" alt="loading" />
                <img *ngIf="!loading" style="width: 50%;" src="./assets/event.jpg" alt="" srcset="">
                <h3 *ngIf="!loading">News and Events</h3>
            </div>
            <div class="features">
                <img *ngIf="loading" style="width: 80%;" (load)="onLoad()" src="/assets/loader.gif" alt="loading" />
                <img *ngIf="!loading" style="width: 50%;" src="./assets/features.jpg" alt="" srcset=""> 
                <h3 *ngIf="!loading">Upcoming Features</h3>
            </div>
        </div>
        
    </div> -->
    <section class="no-padding-top no-padding-bottom">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-3 col-sm-6">
              <div class="statistic-block block">
                <div class="progress-details d-flex align-items-end justify-content-between">
                  <div class="title">
                    <div class="icon"> <a routerLink="/myboard/thrift-board" style="color: inherit;"> <i class="fa fa-pencil-square-o"></i> </a></div><strong>Create A Thrift</strong>
                  </div>
                  <div class="number dashtext-1"> <a routerLink="/myboard/thrift-board" style="color: inherit;"> <i class="fa fa-pencil-square-o"></i> </a></div>
                </div>
                <div class="progress progress-template">
                  <div role="progressbar" style="width: 100%" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100" class="progress-bar progress-bar-template dashbg-1"></div>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="statistic-block block">
                <div class="progress-details d-flex align-items-end justify-content-between">
                  <div class="title">
                    <div class="icon"> <a routerLink="/myboard/organization" style="color: inherit;"> <i class="fa fa-bank"></i></a></div><strong>My Organization</strong>
                  </div>
                  <div class="number dashtext-2"> <a routerLink="/myboard/organization" style="color: inherit;"> <i class="fa fa-bank"></i></a> </div>
                </div>
                <div class="progress progress-template">
                  <div role="progressbar" style="width: 100%" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" class="progress-bar progress-bar-template dashbg-2"></div>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="statistic-block block"> 
                <div class="progress-details d-flex align-items-end justify-content-between">
                  <div class="title">
                    <div class="icon"> <a routerLink="/myboard/txns" style="color: inherit;"> <i class="fa fa-list-ol"></i></a></div><strong>Transactions</strong>
                  </div>
                  <div class="number dashtext-3"><a routerLink="/myboard/txns" style="color: inherit;"> <i class="fa fa-list-ol"></i></a></div>
                </div>
                <div class="progress progress-template">
                  <div role="progressbar" style="width: 100%" aria-valuenow="55" aria-valuemin="0" aria-valuemax="100" class="progress-bar progress-bar-template dashbg-3"></div>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="statistic-block block">
                <div class="progress-details d-flex align-items-end justify-content-between">
                  <div class="title">
                    <div class="icon"><i class="icon-writing-whiteboard"></i></div><strong>News And Announcement</strong>
                  </div>
                  <div class="number dashtext-4"><i class="icon-writing-whiteboard"></i></div>
                </div>
                <div class="progress progress-template">
                  <div role="progressbar" style="width: 100%" aria-valuenow="35" aria-valuemin="0" aria-valuemax="100" class="progress-bar progress-bar-template dashbg-4"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Wallet Actions -->
      <h2 class="h5 pl-3 text-uppercase">Wallet Actions</h2>
      <section class="no-padding-top no-padding-bottom">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-3 col-sm-6">
              <div class="statistic-block block">
                <div class="progress-details d-flex align-items-end justify-content-between">
                  <div class="title">
                    <div class="icon"> </div><strong>Fund Account</strong>
                  </div>
                  <div class="number dashtext-1"> <a routerLink="../wallet" style="cursor: pointer; color: inherit;"><i class="fa fa-credit-card"></i></a> </div>
                </div>
               
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="statistic-block block">
                <div class="progress-details d-flex align-items-end justify-content-between">
                  <div class="title">
                    <div class="icon"> </div><strong>Transfer</strong>
                  </div>
                  <div class="number dashtext-1"> <a  type="button" data-toggle="modal" data-target="#transfer" style="cursor: pointer; color: inherit;"> <i class="fa fa-send"></i> </a></div>
                </div>
               
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="statistic-block block">
                <div class="progress-details d-flex align-items-end justify-content-between">
                  <div class="title">
                    <div class="icon"> </div><strong>Join Thrift</strong>
                  </div>
                  <div class="number dashtext-1"><a  type="button" data-toggle="modal" data-target="#joinThrift" style="cursor: pointer; color: inherit;"><i class="fa fa-group"></i></a> </div>
                </div>
               
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="statistic-block block">
                <div class="progress-details d-flex align-items-end justify-content-between">
                  <div class="title">
                    <div class="icon"> </div><strong>Help</strong>
                  </div>
                  <div class="number dashtext-1"> <i class="fa fa-headphones"></i> </div>
                </div>
               
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- My To do and Notifications -->
      <section class="no-padding-bottom">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-4">
              <div class="checklist-block block">
                <div class="title"><strong>My Reminder List</strong></div>
                <div class="checklist">
                  <div class="item d-flex align-items-center">
                    <input type="checkbox" id="input-1" name="input-1" class="checkbox-template">
                    <label for="input-1">Call Seyi to send his contibution tomorrow.</label>
                  </div>
                  <div class="item d-flex align-items-center">
                    <input type="checkbox" id="input-2" name="input-2" checked class="checkbox-template">
                    <label for="input-2">Pay NCS Cooperaive.</label>
                  </div>
                  <div class="item d-flex align-items-center">
                    <input type="checkbox" id="input-3" name="input-3" class="checkbox-template">
                    <label for="input-3">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</label>
                  </div>
                  <div class="item d-flex align-items-center">
                    <input type="checkbox" id="input-4" name="input-4" class="checkbox-template">
                    <label for="input-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</label>
                  </div>
                  
                </div>
              </div>
            </div>
            <div class="col-lg-4">                                           
              <div class="messages-block block">
                <div class="title"><strong>Notifications</strong></div>
                <div class="messages" >
                  
                  <a routerLink="/myboard" *ngFor="let notification of notifications  | paginate: { itemsPerPage: 5, currentPage: p }; let i = index;" class="message d-flex align-items-center">
                    <div class="profile"><img src="./assets/notify.png" alt="..." class="img-fluid">
                      <div class="status away"></div>
                    </div>
                    <div class="content">  
                       <strong class="d-block">  </strong>
                       <span class="d-block">{{notification?.message}}</span>
                       <small class="date d-block pt-1"> {{notification?.time}} <i class="fa fa-circle"></i> {{notification?.date}} </small>
                      </div>
                    </a>
                   
                  </div>
                  <pagination-controls (pageChange)="p = $event"></pagination-controls>
              </div>
            </div>
            <div class="col-lg-4">                                           
              <div style="background-color: #f1f1f1;" class="messages-block block">
                <img src="../../../assets/woman.jpeg" style="width: 100%; height: 100%;" class="image-fluid" alt="" srcset="">
              </div>
            </div>
          </div>
        </div>
      </section>
    

</section>



